import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/dashboard — aggregate read for the admin landing page.
//
// Single endpoint (not granular) because the inbound-attribution scan feeds
// both the recent-deals panel and the partner leaderboard, and the dashboard
// is a single surface — sub-buckets 10–17 won't reuse these roll-ups.
// Aggregation rationale lives in the service module
// (apps/api/src/services/admin-dashboard.ts).
export type AdminDashboardDeal = {
  hubspotDealId: string;
  dealName: string | null;
  dealAmountEur: number | null;
  dealStageId: string | null;
  dealStageLabel: string | null;
  dealCreatedAt: string | null;
  hubspotUrl: string;
  partnerName: string | null;
};

export type AdminDashboardLeaderboardRow = {
  partnerId: string;
  partnerName: string;
  partnerTier: string | null;
  winCount: number;
  arrEur: number;
};

export type AdminDashboardResponse = {
  metrics: {
    activePartners: number;
    hubspotDealsThisMonth: number;
    openPipelineDealCount: number;
    openPipelineValueEur: number;
    closedWonArrEur: number;
    openMdfFundsCount: number;
    openMdfTotalEur: number;
  };
  recentInboundDeals: AdminDashboardDeal[];
  recentOutboundDeals: AdminDashboardDeal[];
  leaderboard: AdminDashboardLeaderboardRow[];
};

export function useAdminDashboard() {
  return useQuery<AdminDashboardResponse, ApiClientError>({
    queryKey: queryKeys.admin.dashboard(),
    queryFn: () => apiFetch<AdminDashboardResponse>("/admin/dashboard"),
  });
}
